export const sessionTypes = [
  {
    title: "Office Appointment",
    type: "office appointment",
  },
  {
    title: "Phone Call",
    type: "phone",
  },
  { title: "Video", type: "video" },
  {
    title: "Text",
    type: "text",
  },
];
export const sessionLog = [
  {
    sessionType: "Office Appointment",
    date: "12/02/24",
    timeStart: "02:45 PM",
    timeEnd: "03:15 PM",
    duration: "30 minutes",
    notes:
      "Patient expressing concerns about X Y Z. Higher avg BAC over last 4 week period. Inconsistent breathalyzer use.",
  },
  {
    sessionType: "Phone Call",
    date: "01/06/24",
    timeStart: "10:00 AM",
    timeEnd: "10:30 AM",
    duration: "30 minutes",
    notes: "Discussed patient's weekly progress.",
  },
  {
    sessionType: "Phone Call",
    date: "01/10/24",
    timeStart: "02:00 PM",
    timeEnd: "02:15 PM",
    duration: "15 minutes",
    notes: "Follow-up on breathalyzer usage consistency.",
  },
  {
    sessionType: "Office Appointment",
    date: "01/24/24",
    timeStart: "11:00 AM",
    timeEnd: "11:45 AM",
    duration: "45 minutes",
    notes:
      "Detailed discussion about reducing average BAC. New action plan created.",
  },
  {
    sessionType: "Video",
    date: "02/05/24",
    timeStart: "03:00 PM",
    timeEnd: "03:30 PM",
    duration: "30 minutes",
    notes: "Video session to check on patient's adherence to the action plan.",
  },
  {
    sessionType: "Text",
    date: "02/10/24",
    timeStart: "09:00 AM",
    timeEnd: "09:05 AM",
    duration: "5 minutes",
    notes: "Patient reported no alcohol consumption over the weekend via text.",
  },
  {
    sessionType: "Phone Call",
    date: "02/20/24",
    timeStart: "04:00 PM",
    timeEnd: "04:20 PM",
    duration: "20 minutes",
    notes: "Discussed upcoming appointment and progress so far.",
  },
  {
    sessionType: "Office Appointment",
    date: "03/01/24",
    timeStart: "10:30 AM",
    timeEnd: "11:00 AM",
    duration: "30 minutes",
    notes:
      "Review of the past month's progress. Adjustments to the action plan.",
  },
  {
    sessionType: "Video",
    date: "03/15/24",
    timeStart: "01:00 PM",
    timeEnd: "01:30 PM",
    duration: "30 minutes",
    notes: "Mid-month check-in via video. Patient is adhering to the new plan.",
  },
  {
    sessionType: "Text",
    date: "03/20/24",
    timeStart: "07:00 PM",
    timeEnd: "07:05 PM",
    duration: "5 minutes",
    notes:
      "Patient texted about an emergency situation related to alcohol use.",
  },
];
